// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipping-tips[data-v-1bb39f64]{display:grid;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat(2,1fr);grid-gap:24px;width:480px}@media(max-width:1279px)and (min-width:768px){.shipping-tips[data-v-1bb39f64]{width:100%;grid-template-columns:repeat(4,1fr);grid-template-rows:repeat(1,1fr)}}@media(max-width:767px){.shipping-tips[data-v-1bb39f64]{width:368px}}@media(max-width:399px){.shipping-tips[data-v-1bb39f64]{width:346px}}", ""]);
// Exports
module.exports = exports;
